import Layout from 'components/Layout';

import { PlacingPaymentConsumer } from 'contexts/placingPayment';
import ItemList from 'pages/SplitBill/Items/components/ItemsList';

const SplitBillByItem = () => {
  return (
    <PlacingPaymentConsumer>
      {({ paymentInfo }) => {
        return (
          <Layout paymentInfo={paymentInfo} isEmptyPage>
            <ItemList />
          </Layout>
        );
      }}
    </PlacingPaymentConsumer>
  );
};

export default SplitBillByItem;
